<template>
  <div class="column" :class="app.size">
    <div class="card">
      <div class="card-header">
        <p class="card-header-title">{{app.title}}</p>
      </div>
      <router-link :to="'/' + app.title.replace(' ' ,'_')" @click.native="clicked">
        <div v-if="app.screenshot && app.showScreenshot" class="card-image">
          <figure class="image is-16by10">
            <img :src="app.screenshot" :title="app.title">
          </figure>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-64x64">
                <img :src="app.icon" :title="app.title">
              </figure>
            </div>
            <div class="media-content">
              <p class="subtitle">{{app.description}}</p>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    app: {
      type: Object
    }
  },
  methods: {
    clicked() {
      this.$emit("clicked", this.app);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppPreview.vue